
export enum Format {
  Currency = 'USD',                   // standard currency format
  Date = 'MMM dd, yyyy',		          // standard date format used for display - data piping
  MediumDate = 'mediumDate',
  DateWeek = 'EEE MMM dd, yyyy',		  // standard date with day of the week format used for display - data piping
  FnsDataserviceDate = 'yyyy-MM-dd',  // dataservice date format when using date-fns
  FnsTimesheetDate = 'MM/dd/yyyy',    // timesheet header date format when using date-fns

  // FixMe: Angular12Upgrade
  // FnsDataserviceDate = 'YYYY-MM-DD',  // dataservice date format when using date-fns
  // FnsTimesheetDate = 'MM/DD/YYYY',    // timesheet header date format when using date-fns

  Year = 'yyyy',
  MonthAndDay = 'MM/dd',
  DataserviceDate = 'yyyy-MM-dd',	    // standard date format from backend rest api
  PcalendarDate = 'yy-mm-dd',    	    // standard date format for p-calendar, specify [dateFormat]="Format.PcalendarDateFormat"
  ExportDate = 'yyyy-MM-dd h:mm:ss',
  PcalendarTime = '12',               // standard time format for p-calendar, specify [hourFormat]="Format.PcalendarTimeFormat"
  PhoneMask = "(999) 999-9999",       // phone format when using inputmask
  RatioNumber = '1.1-2',              // standard ratio format exp: 3.45, 9.99 for display
  SocialSecurityMask = "999-99-9999", // social security format when using inputmask
  Time = 'MMM dd, yyyy hh:mm a',	    // standard time format for display
  TimesheetDate = 'MM/dd/yyyy',       // timesheet date display format
  TimeZone = 'UTC',                   // standard timezone is UTC
  YearMask = "9999",                  // year format using inputmask
  AgeMask = "99",                     // age format using inputmask
  PercentTwoDecimal = '2.1-2',
  PercentOneDotTwoDecimal = '1.2-2',
  DataTableContainsFilter = 'contains',     // Data table filter mode to perform a "contains" search on data
  DataTableStartsWithFilter = 'startsWith'  // Data table filter mode to perform a "Start with" search on data,

}
